export interface Observation {
    observationData: any
    priority: number
    type: string
    messageText: string
}

export const extractServerDisplayNameFromHostname = (name: string) => name.split('@@')[0]
